/**
 * Created by methee on 9/8/17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose } from 'react-apollo';
import { defineMessages, FormattedMessage } from 'react-intl';

import s from './Hotels.css';
import query from './hotels.graphql';
// import mp from '../../analytic';

import CountrySelection from './CountrySelection';
import CityCard from './CityCard';

const messages = defineMessages({
  ourHotels: {
    id: 'our_hotels.our_hotels',
    defaultMessage: '##Our Hotels##',
    description: 'Our Hotels header text',
  },
});

const heroHeight = 400;
const parallaxVelocity = 8;

class Hotels extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      locations: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { country: null, scrollY: 0 };
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      this.bindOnMouseScroll = this.onMouseScroll.bind(this);
      window.addEventListener('scroll', this.bindOnMouseScroll);
    }
  }

  // componentDidMount() {
  //   mp.track('#Our Hotels');
  // }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.bindOnMouseScroll);
  }

  onMouseScroll = () => {
    this.setState({ scrollY: window.scrollY });
  };

  onSelectedCountry = country => {
    this.setState({ country, city: country.children[0] });
  };

  bindOnMouseScroll = null;

  render() {
    const {
      data: { loading, locations },
    } = this.props;
    let { country } = this.state;
    const { scrollY } = this.state;
    if (country === null && !loading) {
      country = locations[0];
    }
    let cities = [];
    if (country !== null) {
      cities = [...country.children];
    }

    const heroBackgroundStyle = {
      transform: `translateY(${scrollY /
        parallaxVelocity}px) scale(${(heroHeight + scrollY / parallaxVelocity) /
        heroHeight}, ${(heroHeight + scrollY / parallaxVelocity) /
        heroHeight})`,
      opacity: (heroHeight - scrollY) / heroHeight,
    };
    const heroTextStyle = {
      opacity: (heroHeight - (scrollY * parallaxVelocity) / 6) / heroHeight,
    };
    return (
      <div className={s.root}>
        <div className={s.hero}>
          <div className={s.background} style={heroBackgroundStyle} />
          <h1 style={heroTextStyle}>
            <FormattedMessage {...messages.ourHotels} />
          </h1>
        </div>
        {!loading && (
          <div className={s.container}>
            <div className={s.row}>
              <div className={s.col5}>
                <CountrySelection
                  locations={locations}
                  onSelectedCountry={this.onSelectedCountry}
                />
              </div>
              {country !== null && (
                <div className={s.col7}>
                  <CityCard
                    countryId={country.id}
                    city={cities.slice(0, 1)[0]}
                  />
                </div>
              )}
            </div>
            <div className={s.row}>
              {cities.length > 1 &&
                cities.slice(1).map(city => (
                  <div key={city.id} className={s.col6}>
                    <CityCard countryId={country.id} city={city} />
                  </div>
                ))}
              {cities.length % 2 === 0 && (
                <div className={s.col6}>
                  <div className={s.placeholder} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default compose(withStyles(s), graphql(query))(Hotels);
